import React, { FC, InputHTMLAttributes } from 'react';
import ProductFiltersStyled from '../ProductFiltersStyled';
import Select from 'react-select';
import selectStyles from '../selectStyles';
import { trackEvent } from '~/helpers/tracking';
import { useDispatch } from 'react-redux';
import { Option } from '~/types/products';
import { setSelectedSweetener } from '~/redux/actions/products';

interface Props {
  addPhoneState: boolean;
  options: Option[];
  sweetener: Option;
  voiceAvailable: boolean;
  handleAddHomePhone: (event: InputHTMLAttributes<HTMLInputElement>) => void;
  setSweetener: (selected: Option) => void;
}

const ProductFilters: FC<Props> = ({ options, sweetener, voiceAvailable, setSweetener }) => {
  const dispatch = useDispatch();
  if (!voiceAvailable && !options?.length) return null;
  return (
    <ProductFiltersStyled>
      {options.length > 1 && (
        <div className="product-filters__sweetener" data-testid="claim-rewards">
          <Select
            aria-label="Visa Reward Card selection"
            className="product-filters__select"
            styles={selectStyles}
            options={options}
            value={sweetener}
            placeholder=""
            onChange={(selected) => {
              trackEvent({
                action: 'elementClicked',
                data: {
                  elementType: 'TAB',
                  position: 'VRC',
                  action: 'TOGGLE',
                  text: selected?.value,
                },
              });
              dispatch(setSelectedSweetener(selected));
              setSweetener(selected);
            }}
          />
        </div>
      )}
    </ProductFiltersStyled>
  );
};

ProductFilters.displayName = 'ProductFilters';

export default ProductFilters;
